import {useEffect, useState} from "react";
import Loading from "../../component/Loading/Loading";
import {getAllInstallments} from "./functions";
import {Link, useNavigate} from "react-router-dom";
import {PickDateTimeWithoutContainer} from "../../component/PickDate/PickDate";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEye, faPencil, faTrash} from "@fortawesome/free-solid-svg-icons";


const Installments = () => {
    const navigate = useNavigate()

    const [isLoading, setIsLoading] = useState(true);
    const [allInstallmentHistory, setAllInstallmentHistory] = useState([]);

    useEffect(() => {

        (async () => {
            document.title = "اقساط مشتریان";
            const allInstallmentHistory = await getAllInstallments();
            // console.log(allInstallmentHistory);
            setAllInstallmentHistory(allInstallmentHistory);
            setIsLoading(false);
        })();

    }, []);



    if (isLoading)
        return <Loading/>

    return (
        <div className="container-fluid p-0">
            <div className="mb-4">
                <h1 className="h3 d-inline align-middle">اقساط مشتریان</h1>
            </div>

            <div className="row">
                <div className="card">
                    <div className="card-body">
                        <div className="table-responsive">
                            <table className={"table text-center"}>
                                <thead>
                                <tr>
                                    <th width={"5%"}>ردیف</th>
                                    <th width={"5%"}>آیدی</th>
                                    <th width={"15%"}>موعد پرداخت</th>
                                    <th>مبلغ</th>
                                    <th>وضعیت</th>
                                    <th width={"15%"}>زمان پرداخت</th>

                                    <th>نام مشتری</th>
                                    <th>شماره تماس مشتری</th>
                                    <th width={"5%"}>آیدی فاکتور</th>
                                    <th width={"5%"}>مشاهده فاکتور</th>
                                    <th width={"5%"}></th>
                                    <th width={"5%"}></th>
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    allInstallmentHistory.map((installmentHistory, index) => {
                                        return (
                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td>{installmentHistory.id}</td>
                                                <td>
                                                    <PickDateTimeWithoutContainer
                                                        timestamp={installmentHistory.paymentTimestamp}
                                                        disabled={true}/>
                                                </td>
                                                <td>
                                                    {installmentHistory.amount.toLocaleString()}
                                                </td>
                                                <td>
                                                    {!installmentHistory.payedTimestamp && <span className="text-danger">پرداخت نشده</span>}
                                                    {installmentHistory.payedTimestamp && <span className="text-success">پرداخت شده</span>}
                                                </td>
                                                <td>
                                                    {installmentHistory.payedTimestamp && <PickDateTimeWithoutContainer
                                                        timestamp={installmentHistory.payedTimestamp} disabled={true}/>}
                                                </td>
                                                <td>
                                                    {installmentHistory.customer.person.firstname + " " + installmentHistory.customer.person.lastname}
                                                </td>
                                                <td>
                                                    {installmentHistory.customer.person.activePhonenumber}
                                                </td>
                                                <td>
                                                    {installmentHistory.billId}
                                                </td>
                                                <td>
                                                    <Link to={`/orders/update/${installmentHistory.billId}`}
                                                          target={"_blank"}>
                                                        <FontAwesomeIcon icon={faEye}/>
                                                    </Link>
                                                </td>

                                                <td>
                                                    <Link className={"btn btn-secondary"} to={`./update/${installmentHistory.id}`} >
                                                        <FontAwesomeIcon icon={faPencil}/>
                                                    </Link>
                                                </td>

                                                <td>
                                                    <FontAwesomeIcon className={"btn btn-danger"} icon={faTrash}/>
                                                </td>


                                            </tr>
                                        );
                                    })
                                }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>


        </div>
    )
}

export default Installments;